export default "__VITE_ASSET__63e5a727__"